/**
 * Converts a string to title case: first letter of each word is uppercase,
 * remaining letters are lowercase. Handles hyphenated names and apostrophes.
 *
 * Examples:
 *   toTitleCase("JOANNA DAY")   → "Joanna Day"
 *   toTitleCase("smith-jones")  → "Smith-Jones"
 *   toTitleCase("o'brien")      → "O'Brien"
 *   toTitleCase("")             → ""
 *   toTitleCase("   ")          → "   "
 *   toTitleCase("a")            → "A"
 */
export function toTitleCase(value: string): string {
  if (!value) return value;

  return value
    .toLowerCase()
    .replace(/(?:^|\s|[-'])\S/g, (char) => char.toUpperCase());
}
